import { createReducer, INITIAL_STATE } from '@shared/redux';
import { LOAD_STATE } from '@shared/axios';

import { createSelector } from 'reselect';
import {
    CampaignsState, convertCampaignsToHash,
    getCampaigns,
    getCampaignsReportsConfig,
    GetCampaignsReportsStatsParams,
} from '@domain/campaigns';

export const HANDLE_GET_COMPARISON_CAMPAIGNS = '@comparison-campaigns/HANDLE_GET_COMPARISON_CAMPAIGNS';
export const GET_COMPARISON_CAMPAIGNS_CUSTOMER_ID_REQUEST_CALLED = '@comparison-campaigns/GET_CAMPAIGNS_CUSTOMER_ID_REQUEST_CALLED';
export const GET_COMPARISON_CAMPAIGNS_CUSTOMER_ID_REQUEST_SUCCEEDED = '@comparison-campaigns/GET_CAMPAIGNS_CUSTOMER_ID_REQUEST_SUCCEEDED';
export const GET_COMPARISON_CAMPAIGNS_CUSTOMER_ID_REQUEST_FAILED = '@comparison-campaigns/GET_CAMPAIGNS_CUSTOMERS_ID_REQUEST_FAILED';
export const GET_COMPARISON_CAMPAIGNS_CUSTOMERS_ID_REQUEST_CANCELED = '@comparison-campaigns/GET_CAMPAIGNS_CUSTOMERS_ID_REQUEST_CANCELED';

const initialState: CampaignsState = {
    loadState: LOAD_STATE.LOADING,
    data: {},
    error: null,
    warning: null,
};

export const getComparisonCampaignsSelector = createSelector([
    getCampaigns,
], campaigns => ({
    ...campaigns,
    data: Object.values(campaigns.data),
}));

export const handleGetComparisonCampaigns = () => ({
    type: HANDLE_GET_COMPARISON_CAMPAIGNS,
    payload: {},
});

export const getComparisonCampaignsReportsStats = ({
    customerType,
    customerId,
    startDate,
    endDate,
    isNewOverview,
    conversionType,
}: GetCampaignsReportsStatsParams) => ({
    type: GET_COMPARISON_CAMPAIGNS_CUSTOMER_ID_REQUEST_CALLED,
    actionTypes: {
        success: GET_COMPARISON_CAMPAIGNS_CUSTOMER_ID_REQUEST_SUCCEEDED,
        fail: GET_COMPARISON_CAMPAIGNS_CUSTOMER_ID_REQUEST_FAILED,
        canceled: GET_COMPARISON_CAMPAIGNS_CUSTOMERS_ID_REQUEST_CANCELED,
    },
    config: getCampaignsReportsConfig({
        customerType,
        customerId,
        startDate,
        endDate,
        isNewOverview,
        conversionType,
    }),
});

export const comparisonCampaignsReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [GET_COMPARISON_CAMPAIGNS_CUSTOMER_ID_REQUEST_CALLED]: state => ({
        ...state,
        loadState: LOAD_STATE.LOADING,
        data: {},
        error: null,
    }),
    [GET_COMPARISON_CAMPAIGNS_CUSTOMER_ID_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.SUCCESS,
        data: convertCampaignsToHash({ report: action.payload.data }),
        error: null,
    }),
    [GET_COMPARISON_CAMPAIGNS_CUSTOMER_ID_REQUEST_FAILED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.FAIL,
        data: {},
        error: action.payload,
    }),
    [GET_COMPARISON_CAMPAIGNS_CUSTOMERS_ID_REQUEST_CANCELED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.LOADING,
        data: {},
        error: action.payload,
    }),
});
